// extracted by mini-css-extract-plugin
export default {"box":"formSelect_box__yQnAy","box__select":"formSelect_box__select__UFIEs","box__option":"formSelect_box__option__bG4JJ"};